import { parametersServices } from "../../../services";

export async function LanguageTypes() {
	const languageTypes = await parametersServices.getLanguageTypes();

	const columns = [
		{
			key: "id",
			name: "#",
			sort: 0,
			type: "id",
		},
		{
			key: "value",
			name: "static-parameters.title",
			sort: 1,
			type: "title",
		},
		{
			key: "key",
			name: "static-parameters.key",
			sort: 2,
			type: "title",
		},
	];
	const rows = [];

	await languageTypes.payload?.map((languageType, key) => {
		rows.push({
			id: key + 1,
			value: languageType.value,
			key: languageType.key,
		});
	});
	const tableData = {
		columns: columns,
		rows: rows,
	};
	return tableData;
}
